import { Modal, Button } from "react-bootstrap";
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
const phoneRegExp =
  /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

// const phoneRegExp = /^(07|09)\d{8}$/;

const basicSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .required("Phone is required")
    .test("phone-match", "Invalid phone number", (value) =>
      phoneRegExp.test(value)
    ),
  email: Yup.string().required("Email is required"),
  status: Yup.string().required("Status is required"),
});

const AddAgent = ({ showModal, hideModal, getAgents }) => {
  const history = useNavigate();

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    addAgent(values);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      status: "",
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const notifySuccess = () =>
    toast.success("Agent Added.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const addAgent = async (e) => {
    console.log("emfsdf", e);
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }

      const response = await axios.post("/agent", bodyFormData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      });
      // history("/vehicleTypes");
      getAgents();
      hideModal();
      notifySuccess();
      console.log(response.status);
    } catch (error) {
      console.log(error.response);
      if (error.response) {
        notifyError();
      }
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
       style={{marginTop: "60px"}} 
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Agent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="row">
            <div class="col-md-12">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="name">Name</label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.name && touched.name
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.name && touched.name && (
                      <p className="error">{errors.name}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="phone">Phone</label>
                    <input
                      type="number"
                      name="phone"
                      id="phone"
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.phone && touched.phone
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.phone && touched.phone && (
                      <p className="error">{errors.phone}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="id">Email</label>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.email && touched.email
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.email && touched.email && (
                      <p className="error">{errors.email}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label for="status">Status</label>
                    <select
                      id="status"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.status && touched.status
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Status</option>

                      <option key={"Active"} value={"Active"}>
                        {"Active"}
                      </option>
                      <option key={"Inactive"} value={"Inactive"}>
                        {"Inactive"}
                      </option>
                    </select>
                    {errors.status && touched.status && (
                      <p className="error">{errors.status}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>

          <button
            disabled={isSubmitting}
            onClick={submitForm}
            className="btn btn-success"
            type="submit"
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default AddAgent;
